import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-83">
          {/* Visual Badge/Stamp */}
          <div className="flex justify-center mb-8" data-id="element-84">
            <div className="inline-flex items-center gap-3 bg-brand-red/10 border-4 border-brand-red rounded-full px-8 py-4" data-id="element-85">
              <ShieldCheckIcon className="w-8 h-8 text-brand-red" aria-hidden="true" data-id="element-86" />
              <span className="text-xl font-bold text-brand-red" data-id="element-87">
                THE CROWNCONTROL™ GUARANTEE
              </span>
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center leading-tight" data-id="element-88">
            We Take the Risk. Not You.
          </h2>

          {/* Opening Statement */}
          <div className="mb-8" data-id="element-89">
            <p className="text-lg text-gray-700 leading-relaxed text-center" data-id="element-90">
              Here's our position: we know this protocol works when it is used
              correctly and consistently. We know the mechanism is real. We know
              the device delivers what it's supposed to deliver.
            </p>
            <p className="text-lg text-gray-900 font-semibold text-center mt-4" data-id="element-91">
              So we're taking the financial risk off the table.
            </p>
          </div>

          {/* The 180-Day Guarantee */}
          <div className="bg-gray-50 rounded-lg p-8 mb-8" data-id="element-92">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-93">
              The 180-Day "See It or It's Free" Guarantee
            </h3>

            <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-94">
              Use CrownControl™ exactly as directed for 180 days.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-95">
              If you don't see meaningful improvement in your hair — less
              shedding, thicker coverage, or visible new growth — email us
              within 180 days of your purchase.
            </p>

            <p className="text-lg text-gray-900 font-semibold mb-4" data-id="element-96">
              We will refund your purchase in full. No photos required. No
              forms. No "you didn't follow the protocol correctly" games.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-97">
              We make this offer because we are confident in the science,
              confident in the device, and confident that a man who commits to
              the protocol will see a change he can notice in the mirror.
            </p>
          </div>

          {/* Closing Statement */}
          <div className="text-center" data-id="element-98">
            <p className="text-xl text-gray-900 font-semibold mb-2" data-id="element-99">
              You risk time and 10 minutes a day. We risk the money.
            </p>
            <p className="text-lg text-gray-700" data-id="element-100">
              The only way you lose here is if you don't try while you still
              have the leverage.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}